import * as React from 'react';
import Container from "react-bootstrap/Container";
import NavbarComponent from './NavbarComponent';
import TableComponent from './TableComponent';
import { Route, Switch } from 'react-router-dom';

interface MainState {
    tableSearch: string, fieldSearch: string, wholeWords: boolean;
}

export default class FieldsMain extends React.Component<{}, MainState>
{

    constructor(props: {}) {
        super(props);

        this.state = {tableSearch: "", fieldSearch: "", wholeWords: false};
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    private onSearchChange(tableSearch: string, fieldSearch: string, wholeWords: boolean) {
        this.setState({tableSearch: tableSearch, fieldSearch: fieldSearch, wholeWords: wholeWords});
    }

    public render(): JSX.Element
    {
        return (
            <>
                <NavbarComponent onSearchChange={this.onSearchChange} /> 
                <Container fluid>
                        <TableComponent tableFilter={this.state.tableSearch} fieldFilter={this.state.fieldSearch} wholeWords={this.state.wholeWords} />
                </Container>
            </>
        );
    }
}